document.querySelectorAll('.product-purchase-form').forEach(function (form) {
  var quantity = form.querySelector('input[name="quantity"]');
  var decrease = form.querySelector('[data-quantity-decrease]');
  var increase = form.querySelector('[data-quantity-increase]');
  var variantInput = form.querySelector('[data-variant-id-input]');
  var variantPicker = document.querySelector('[data-product-variant-picker]');
  var variantData = document.querySelector('[data-product-variants]');
  var addButton = form.querySelector('[data-add-to-cart]');
  var priceTargets = document.querySelectorAll('[data-product-price], [data-buy-box-price]');
  var totalTarget = form.querySelector('[data-order-total]');
  var availabilityTarget = document.querySelector('[data-product-availability]');
  var gallery = document.querySelector('[data-product-gallery]');
  var currency = document.documentElement.getAttribute('data-currency') || 'USD';
  var locale = document.documentElement.lang || 'en';
  var variants = [];
  var selectedVariant = null;

  if (variantData) {
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      variants = [];
    }
  }

  function normalizeQuantity(value) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed < 100) return 100;
    return Math.ceil(parsed / 100) * 100;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function variantById(id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function variantFromOptions() {
    if (!variantPicker) return null;
    var optionSelects = Array.from(variantPicker.querySelectorAll('[data-product-option]'));
    if (!optionSelects.length) return null;
    var selectedOptions = optionSelects.map(function (select) {
      return select.value;
    });

    return variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selectedOptions[index];
      });
    });
  }

  function variantMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    return '';
  }

  function showVariantMedia(variant) {
    var mediaId = variantMediaId(variant);
    if (gallery && mediaId) {
      gallery.dispatchEvent(new CustomEvent('product:show-media', {
        detail: { mediaId: String(mediaId) }
      }));
    }
  }

  function updatePicker(variant) {
    if (!variantPicker || !variant) return;

    variantPicker.querySelectorAll('[data-variant-swatch]').forEach(function (swatch) {
      var swatchVariant = variantById(swatch.getAttribute('data-variant-id'));
      var selected = String(swatch.getAttribute('data-variant-id')) === String(variant.id);
      var available = swatchVariant ? Boolean(swatchVariant.available) : true;
      swatch.classList.toggle('is-selected', selected);
      swatch.classList.toggle('is-unavailable', !available);
      swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
      swatch.setAttribute('aria-disabled', available ? 'false' : 'true');
    });

    variantPicker.querySelectorAll('[data-product-option]').forEach(function (select) {
      var optionIndex = Number(select.getAttribute('data-product-option'));
      if (variant.options[optionIndex] !== undefined) {
        select.value = variant.options[optionIndex];
      }
    });

    variant.options.forEach(function (option, index) {
      var valueTarget = variantPicker.querySelector('[data-selected-option-value="' + index + '"]');
      if (valueTarget) valueTarget.textContent = option;
    });
  }

  function updatePurchase(variant) {
    var normalized = normalizeQuantity(quantity.value);
    quantity.value = String(normalized);
    selectedVariant = variant || selectedVariant;

    var fallbackPrice = Number(form.querySelector('[data-default-price]').getAttribute('data-default-price')) || 0;
    var price = selectedVariant ? Number(selectedVariant.price) || 0 : fallbackPrice;
    var available = selectedVariant ? Boolean(selectedVariant.available) : !addButton.disabled;

    if (selectedVariant) {
      variantInput.value = selectedVariant.id;
      updatePicker(selectedVariant);
    }

    priceTargets.forEach(function (target) {
      target.textContent = formatMoney(price);
    });
    totalTarget.textContent = formatMoney(price * normalized);

    addButton.disabled = !available;
    availabilityTarget.textContent = available
      ? availabilityTarget.getAttribute('data-available-text')
      : availabilityTarget.getAttribute('data-unavailable-text');
    availabilityTarget.classList.toggle('availability--available', available);
    availabilityTarget.classList.toggle('availability--unavailable', !available);
  }

  function selectVariant(variant) {
    if (!variant) return;
    updatePurchase(variant);
    showVariantMedia(variant);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    form.dispatchEvent(new CustomEvent('product:variant-change', {
      bubbles: true,
      detail: { variant: variant }
    }));
  }

  if (variantPicker) {
    variantPicker.addEventListener('dragstart', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-variant-swatch]')) {
        event.preventDefault();
      }
    });

    variantPicker.addEventListener('click', function (event) {
      var target = event.target;
      var swatch = target && target.closest ? target.closest('[data-variant-swatch]') : null;
      if (!swatch || !variantPicker.contains(swatch)) return;
      event.preventDefault();
      selectVariant(variantById(swatch.getAttribute('data-variant-id')));
    });

    variantPicker.querySelectorAll('[data-product-option]').forEach(function (select) {
      select.addEventListener('change', function () {
        selectVariant(variantFromOptions());
      });
    });
  }

  decrease.addEventListener('click', function () {
    quantity.value = String(Math.max(100, normalizeQuantity(quantity.value) - 100));
    updatePurchase(selectedVariant);
  });

  increase.addEventListener('click', function () {
    quantity.value = String(normalizeQuantity(quantity.value) + 100);
    updatePurchase(selectedVariant);
  });

  quantity.addEventListener('change', function () {
    updatePurchase(selectedVariant);
  });
  quantity.addEventListener('blur', function () {
    updatePurchase(selectedVariant);
  });

  form.addEventListener('submit', function () {
    quantity.value = String(normalizeQuantity(quantity.value));
  });

  selectedVariant = variantById(variantInput.value);
  updatePurchase(selectedVariant);
  showVariantMedia(selectedVariant);
});
